module.exports = __webpack_public_path__ + "assets/tiantianquan.fa1792cf.svg";